import angular from 'angular';
import _ from 'underscore';

function _sortTimezones(timezones) {
  const americaTopTimezones = _.filter(timezones, timezone => {
    return timezone.match(americaTopRegexp);
  });
  americaTopTimezones.reverse();

  const americanTimezones = _.filter(timezones, timezone => {
    return timezone.match(nonAmericaRegexp) && !timezone.match(americaTopRegexp);
  });

  const nonAmericaTimezones = _.filter(timezones, timezone => {
    return !timezone.match(nonAmericaRegexp);
  });

  return americaTopTimezones.concat(americanTimezones).concat(nonAmericaTimezones);
}

const americaTopRegexp = new RegExp(/^America\/(New_York|Montreal|Los_Angeles|Chicago)$/);
const nonAmericaRegexp = new RegExp(/^America.*$/);

function SettingsVenueSettingsCtrl($scope, $state, $window, $q, $stateParams, $timeout, sdkVenueService, sdkUtils, timezoneService, countryService, alertService, tagService, formHelpersService, mapperService, visibilityHelpersService, ERROR_MESSAGES, venueService) { //eslint-disable-line
  $scope.venuePromise = sdkVenueService.readById($stateParams.venueId);

  _initScope();

  $q.all([
      $scope.venuePromise,
      _getTags()
    ])
    .then(results => {
      $scope.venue = results[0];

      $scope.venueEditForm = mapperService.mapApiToVenue(angular.copy($scope.venue), $scope.tags, $scope.countries);
      $scope.venueEditForm.reservationNoteEnabled = !!($scope.venueEditForm.config && $scope.venueEditForm.config.reservationNote);
      $scope.venueEditForm.guestlistNoteEnabled = !!($scope.venueEditForm.config && $scope.venueEditForm.config.guestlistNote);
    })
    .finally(() => {
      $scope.loading = false;
    });

  function _initScope() {
    $scope.loading = true;
    $scope.timezones = _sortTimezones(timezoneService.list());
    $scope.countries = countryService.list();
    $scope.reservationNoteOptions = {
      toolbar: [
        ['style', ['style']],
        ['style', ['bold', 'italic', 'underline']],
        ['fontsize', ['fontsize']],
        ['insert', ['link']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']]
      ],
      height: 140
    };
    $scope.termsAndConditionsOptions = {
      toolbar: [
        ['style', ['bold', 'ul']],
        ['insert', ['link', 'hr']]
      ],
      height: 140
    };

    $scope.isOnTablelist = function(venue) {
      return visibilityHelpersService.isOnTablelist(venue);
    };

    $scope.saveVenue = _saveVenue;

    $scope.inventorySortOrders = [{
      name: 'Price - Low to high',
      value: 'PRICE_LOW_TO_HIGH'
    }, {
      name: 'Price - High to low',
      value: 'PRICE_HIGH_TO_LOW'
    }];
  }

  // Show fee headers
  $scope.showFeeHeaders = false;

  // Used by the fees directive
  $scope.feesConfig = {};

  $scope.addFee = () => {
    $scope.showFeeHeaders = true;
    if ($scope.feesConfig.initialized) {
      $scope.feesConfig.add();
    }
  };

  $scope.groupTimezones = function(item) {
    return item && item.key ? item.key.split('/')[0] : '';
  };

  function _getTags() {
    return tagService.list()
      .then(tags => {
        $scope.tags = tags;

        $scope.venueTypeTags = _.filter($scope.tags, tag => {
          return tag.key === 'VENUE_TYPE';
        });

        $scope.venueDressCodeOkTags = _.filter($scope.tags, tag => {
          return tag.key === 'DRESS_CODE_OK';
        });

        $scope.venueDressCodeNotOkTags = _.filter($scope.tags, tag => {
          return tag.key === 'DRESS_CODE_NOT_OK';
        });
      })
      .catch(() => {
        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_TAGS);
      });
  }

  function _saveVenue(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;
    $scope.errors = [];

    if (!form.$valid) {
      $scope.errors = formHelpersService.getFormErrors(form);
      console.log(form);
      return;
    }

    const changedValues = formHelpersService.getChangedFormValues(form);

    if (('reservationNoteEnabled' in changedValues) && !changedValues.reservationNoteEnabled) changedValues.reservationNote = null;
    if (('guestlistNoteEnabled' in changedValues) && !changedValues.guestlistNoteEnabled) changedValues.guestlistNote = null;

    const venueTypeTag = _.findWhere($scope.venue.tags, {
      key: 'VENUE_TYPE'
    });

    changedValues.venueTypeTag = venueTypeTag ? venueTypeTag.value : null;
    changedValues.tags = $scope.venueEditForm.tags;

    const venueUpdateData = mapperService.mapVenueToApi(changedValues, $scope.tags);

    $scope.savingVenue = true;

    sdkVenueService.updateById($scope.venue.id, venueUpdateData)
      .then(result => {
        $scope.venue = result;
        $scope.venueEditForm = mapperService.mapApiToVenue($scope.venue, $scope.tags, $scope.countries);

        const currentVenue = venueService.getCurrentVenue();

        if (currentVenue.id === result.id) {
          venueService.setCurrentVenue(result);
        }

        alertService.success('Venue updated');
      })
      .catch(error => alertService.error(sdkUtils.getErrorFromResponse(error)))
      .finally(() => {
        $scope.savingVenue = false;
        $scope.submitted = false;

        form.$setUntouched(); //reset the form values
      });
  }
}

SettingsVenueSettingsCtrl.$inject = [
  '$scope',
  '$state',
  '$window',
  '$q',
  '$stateParams',
  '$timeout',
  'jsSdk.venue',
  'jsSdk.utils',
  'timezoneService',
  'countryService',
  'alertService',
  'jsSdk.tag',
  'formHelpersService',
  'mapperService',
  'visibilityHelpersService',
  'ERROR_MESSAGES',
  'venueService'
];

export default SettingsVenueSettingsCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsVenueSettings/settingsVenueSettingsCtrl.js